import { LatestResearch } from "pages/latestResearch/LatestResearch";

export const MostPopular = LatestResearch;
